'use strict';

import scrollIntoView from '../components/scrollIntoView';

var base = require('./base');
var GtmEvents = require('../seo/gtm/gtmEvents');

/**
 * Remove slides and updates it with the given once.
 * @param {Swiper Obj} container
 * @param {Dom element} slide
 */
const updateSwiperSlide = (container, slide) => {
    container.removeAllSlides();
    container.appendSlide(slide);
    container.update();
};

const GtmProductDetails = () => {
    // send data to dataLayer when land into pdp page
    if($('.product-detail').length === 0) return;
    var items = [];
    var product = {};
    var currency = $('.product-detail').attr('data-currency');
    product.name = $('.product-detail').attr('data-productname');
    product.id = $('.product-detail').attr('data-id');
    product.price = $('.product-detail').attr('data-price');
    product.brand = $('.product-detail').attr('data-brand');
    product.color = $('.product-detail').attr('data-color');
    product.description = $('.product-detail').attr('data-description');
    product.gender = $('.product-detail').attr('data-gender');
    product.link = $('.product-detail').attr('data-link');
    product.material = $('.product-detail').attr('data-material');
    product.product_type = $('.product-detail').attr('data-producttype');
    product.season = $('.product-detail').attr('data-season');
    product.theme = $('.product-detail').attr('data-theme');
    product.size = $('.product-detail').attr('data-size');
    base.retrieveGTMcategories('.product-detail',product);

    //variant
    items.push(product);
    GtmEvents.sendProductDetailsData(currency, items);
};

/**
 * Update image in pdp
 * @param {Object} response
 */
const updateImages = (response) => {
    const swiperThumbs = document.querySelector('.swiper-container.gallery-thumbs').swiper;
    const swiperMain = document.querySelector('.swiper-container.gallery-main').swiper;
    const swiperThumbsModal = document.querySelector('.swiper-container.gallery-thumbs-modal').swiper;
    const swiperMainModal = document.querySelector('.swiper-container.gallery-main-modal').swiper;


    if($(response.container.prevObject[0]).hasClass('color-attribute')) {
        updateSwiperSlide(swiperThumbs, response.data.product.updatedSlides);
        updateSwiperSlide(swiperMain, response.data.product.updatedSlides);
        updateSwiperSlide(swiperThumbsModal, response.data.product.updatedSlides);
        updateSwiperSlide(swiperMainModal, response.data.product.updatedSlides);
    }
};

class Detail {
    constructor () {
        this.productImageModal = '#imageModal';
    }

    closeProductZoom () {
        // Close product zoom modal on double click on desktop devices only
        /*
        $('body').on('dblclick', this.productImageModal, (e) => {
            if (Breakpoints.is('lgUp')) {
                $(e.currentTarget).modal('toggle');
            }
        });
        */
    }

    desktopVerticalCarousel () {
        let verticalCarousel = '[data-carousel="pdpDesktopVerticalCarousel"]'; // Vertical carousel
        let lgDown = Breakpoints.get('lgDown');

        // Initialize the carousel on load if the viewport is greater than 'lg'
        if (Breakpoints.is('lgUp')) {
            desktopVerticalCarousel.set(verticalCarousel);
        }

        // Uninitialize the carousel on resize if the viewport is lower than 'lg'
        lgDown.on('enter', () => {
            desktopVerticalCarousel.unset(verticalCarousel);
        });

        // Initialize the carousel on resize if the viewport is greater than 'lg'
        lgDown.on('leave', () => {
            desktopVerticalCarousel.set(verticalCarousel);
        });
    }

    updateAttributesAndDetails () {
        $('body').on('product:statusUpdate', function (e, data) {
            const product = data.product;
            const resources = data.resources;
            var $productContainer = $('.product-detail');

            if (product.longDescription) {
                $productContainer.find('.longDescription')
                    .removeClass('hidden-xl-down');
                let descriptionHtml = '<p class="pt-2">';
                if (product.shortDescription) {
                    descriptionHtml = product.shortDescription;
                }
                descriptionHtml += '</p>';
                descriptionHtml += '<p>' + resources.productIdLabel + ': ' + product.selectedVariationProductId + '</p>';
                descriptionHtml += product.longDescription;
                $productContainer.find('.longDescription .content')
                    .empty()
                    .html(descriptionHtml);
            } else {
                $productContainer.find('.longDescription')
                    .addClass('hidden-xl-down');
            }
        });
    }

    mobileSlickPagination () {
        let mobileZoomCarousel =  $('[data-carousel="pdpMainPicMobile"]');

        mobileZoomCarousel.on('afterChange', (slick, slide) => {
            $(this.productImageModal).find('.current-page').empty().append(slide.currentSlide + 1);
        });

        $(this.productImageModal).on('show.bs.modal', function (e) {
            let currentPageNumber = parseInt($(e.relatedTarget).attr('data-image-number'));
            let totalSlidesNumber = mobileZoomCarousel.slick('getSlick').slideCount;

            $(e.currentTarget).find('.current-page').empty().append(currentPageNumber + 1);
            $(e.currentTarget).find('.total-pages').empty().append(totalSlidesNumber);
        });
    }

    setStartingSlideNumber () {
        $(this.productImageModal).on('show.bs.modal', function (e) {
            let currentImageNumber = $(e.relatedTarget).attr('data-image-number'); // Get the current image number being clicked

            // Set the current image number being clicked as starting slide for modal carousel. On tablet and desktop devices, currentImageNumber is decreaed by 1 if the total pdp images is greater than one, since the first PDP image is reapeted on the left-side vertical carousel. Without this modification, zoom would not work properly
            $(e.currentTarget).find('.slick-carousel').slick('slickGoTo', currentImageNumber > 0 && $(window).width() >= Breakpoints.get('sm').min ? currentImageNumber - 1 : currentImageNumber);
        });
    }


    showSpinner () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    }

    gtmSendProductDetails () {
        GtmProductDetails();
    }

    updateAttribute () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            updateImages(response);
            if ($('.product-detail>.bundle-items').length || $('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                $('.product-detail').attr('data-id', response.data.product.id);
                if (response.data.product.gtmAdditionalData && response.data.product.gtmAdditionalData.color) {
                    $('.product-detail').attr('data-color', response.data.product.gtmAdditionalData.color);
                }
                if (response.data.product.gtmAdditionalData && response.data.product.gtmAdditionalData.size) {
                    $('.product-detail').attr('data-size', response.data.product.gtmAdditionalData.size);
                }
                // sonar code issue. same code block as above
                // } else if ($('.product-set-detail').eq(0)) {
                //     response.container.data('pid', response.data.product.id);
                //     response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
                $('.product-detail:not(".bundle-item")').attr('data-id', response.data.product.id);
            }
            // send product details on change variant.
            GtmProductDetails();
        });
    }

    updateAddToCart () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);

            //update message "select attribute" visibility
            if($('button.add-to-cart').is(':disabled')){
                $('.select-styles-alert').removeClass('d-none');
            }else{
                $('.select-styles-alert').addClass('d-none');
            }
        });
    }

    updateAvailability () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    }

    imageOpen () {
        $(this.productImageModal).on('shown.bs.modal', function () {
            $('.slick-carousel')[0].slick.setPosition();
        });
    }

    clickThumb () {
        $(document).on('click', '.product-thumb-img', function (e){
            var mediumUrl = $(e.currentTarget).data('medium');
            $('.main-image').parent().find('source').attr('srcset', mediumUrl);
            $('.main-image').attr('src', mediumUrl);
        });
    }

    extendedDetailsScroll () {
        $('.js-extended-details-link').on('click', (e) => {
            e.preventDefault();
            const target = $('.js-extended-details-link').attr('href');
            scrollIntoView(target);
        });
    }

    showMore () {
        $('.js-show-more-button').on('click', () => {
            const parent = $('.js-show-more-button').closest('.show-more');
            parent.removeClass('show-more').addClass('show-more-expanded');
        });
    }

    hide360HelperImage () {
        $('.container-360').on('click touchend', () => {
            if ($('.helper-image-360:visible').length) {
                $('.helper-image-360').fadeOut();
            }
        });
    }

    init360 () {
        /*
        Load and fit 360 images
         */
        const load360 = (url) => {
            $('.ui-360-container').hsl({
                url: url,
                autoRotation: false,
                rotation: false,
                autoRotate: false,
                withCredentials: false,
                hasButtons: false,
                load: () => {
                    this.fit360();
                }
            });
        };

        $('.product-detail  [data-toggle="pill"]').on('shown.bs.tab', (e) => {
            if (e.target.id === 'pills-360-tab') {
                if ($('.ui-360-container').children().length) {
                    this.fit360();
                } else {
                    const url = $('.ui-360-container').attr('hsl-url');
                    load360(url);
                }
            }
        });

        /*
        Rebuild 360 images on variation change
         */
        $('body').on('product:afterAttributeSelect', (e, data) => {
            // check if 360 is enabled to show/hide nav pills
            if (!data.data.product.images360.enabled) {
                $('#pills-gallery-tab').tab('show');
                $('.image-carousel-container').removeClass('images-360-active');
                $('#pills-360').addClass('d-none');
                $('#pills-tab').addClass('d-none');
                return;
            } else {
                $('#pills-tab').removeClass('d-none');
                $('#pills-360').removeClass('d-none');
                $('.image-carousel-container').addClass('images-360-active');
            }

            const newContainer = $('<div>').addClass('ui-360-container');
            $('.ui-360-container').replaceWith(newContainer);

            load360(data.data.product.images360.url);
        });

        /*
        Fit 360 images on window resize
         */
        $(window).resize(this.fit360);
    }

    fit360 () {
        const containerWidth = $('.container-360').innerWidth();
        const size = Math.min(containerWidth, 520);

        $('.ui-360-container').width(size).height(size).hsl('fit');
    }

    get init () {
        return {
            availability: base.availability(),
            addToCart: base.addToCart(),
            //closeProductZoom: this.closeProductZoom(),
            //desktopVerticalCarousel: this.desktopVerticalCarousel(),
            focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
            //mobileSlickPagination: this.mobileSlickPagination(),
            //setStartingSlideNumber: this.setStartingSlideNumber(),
            showSpinner: this.showSpinner(),
            updateAttribute: this.updateAttribute(),
            updateAddToCart: this.updateAddToCart(),
            updateAvailability: this.updateAvailability(),
            gtmSendProductDetails: this.gtmSendProductDetails(),
            //imageOpen: this.imageOpen(),
            updateAttributesAndDetails: this.updateAttributesAndDetails(),
            //clickThumb: this.clickThumb(),
            extendedDetailsScroll: this.extendedDetailsScroll(),
            showMore: this.showMore(),
            hide360HelperImage: this.hide360HelperImage(),
            init360: this.init360(),
            handleColorVariationSwatches: base.handleColorVariationSwatches(),
        };
    }
}

const detail = new Detail;
export default detail;
